export enum DeliveryTypeDto {
  MainRelease = 'main_release',
  ServiceRelease = 'service_release',
  Hotfix = 'hotfix'
}
